<!-- <mat-card class="back">
        <div>
                <h4>About Us:</h4>

                <p>Working on the grounds of innovation, quality and customer satisfaction. All our products are
                        peerless in quality,
                        outstanding in designs and pattern and are in accordance with the latest market trends. We
                        encourage innovative ideas
                        and creativity that surely help any organization grow in the contemporary market and in the long
                        run.</p>
                <p>
                        As an honest and dedicated organization, we aim at setting new milestones and reaching new
                        heights,
                        while maintaining
                        the uniqueness of our products. We constantly endeavor to satisfy the diverse and specialized
                        requirements of our buyers
                        and hence customize our products to match their requirements at the earliest. Designing and
                        fabricating
                        beautiful
                        handicrafts having aesthetic sense reflects our passion for work. Our research and development
                        department continuously
                        works to add a blend of creativity and uniqueness to our existing range.
                </p><br>

                <h4>Our Fabrics:</h4>
                <p>

                        All fabrics manufactured by us are with more technical involvement to setup the construction
                        suitable
                        for furnishing
                        market, keeping the standard parameters intact. The fabric range includes 100% Polyester, 100%
                        Silk,
                        Cotton, Linen and
                        its Blends for Home Furnishing and contract market, meeting light fastness and flammability test
                        standards.
                </p><br>

                <h4>
                        Our Products:

                </h4>

                <p>All the products manufactured by us are a perfect blend of creativity and elegance which have helped
                        us
                        meet the
                        specific requirements of the customers. Our impressive range of products include:
                </p>


                <table class="table table-bordered">
                        <thead>
                                <tr>
                                        <th scope="row">Home Furnishings</th>

                                </tr>
                        </thead>
                        <tbody>
                                <tr>
                                        <th scope="row">1</th>
                                        <td>Drapery panel Rod packet</td>
                                        <td>Bed Spreads</td>
                                        <td>Bed Cover</td>
                                </tr>
                                <tr>
                                        <th scope="row">2</th>
                                        <td>Drapery panel Pinch pleated</td>
                                        <td>Quilts</td>
                                        <td>Pillow Covers</td>
                                </tr>
                                <tr>
                                        <th scope="row">3</th>
                                        <td>Drapery panel Invert pleated</td>
                                        <td>Duvet Covers</td>
                                        <td>Comforter sets</td>
                                </tr>
                        </tbody>
                </table><br>

                <h4>Our Infrastructure:</h4>

                <p>Our elegant and world class infrastructure enables us to run our business effectively and
                  efficiently.Home fabrics is equipped with integrated vertical manufacturing process including yarn
                   preparation, yarn dyeing, weaving, finishing and stitching.
                   It is equipped with technically proven high-tech modern technology twisting, automatic warping
                   machine and advanced European dyeing and weaving machines.
                   Our team of efficient professionals, dedicated expert workers and innovative designers undertake
                   orders expeditiously and work to satisfy the requirements of the customers.
                   All this is managed in about 41,400 square feet with the help of about 300 employees.
                </p><br>

                <h4>Our Quality:</h4>

                <p>

                        The Mill operation is integrated through computer network for efficient process control and the
                        parameters are
                        controlled and checked in every stage to achieve the final product to the customer
                        satisfaction.. The
                        products are
                        inspected by experienced and exposure to international market quality need. Company can meet
                        international standards of
                        color fastness to light and flammability test requirements, also ensuring color matching to the
                        customer
                        satisfaction.
                </p><br>

                <h4>
                        Our Potential:
                </h4>

                <p>
                        Our constant commitment for excellence has enabled us to earn reputation and strength in the
                        market. Our
                        main strength
                        in developing fabric is that we work very closely with every product with warp and weft balanced
                        construction to get
                        good coverage and good hand feel. Our each design is unique and executed with utmost care. We
                        export our
                        elegant
                        collection of Home Furnishings, Fabrics and other products to countries like USA, Europe and
                        South East
                        Asia. Our
                        products have been highly acclaimed for their soothing colors and eye catching designs.
                </p>
        </div>

        <h3>Company Profile</h3>
        <div>
                <table class="table">
                        <tbody>
                                <tr>
                                        <td class="table-data">Business Type</td>
                                        <td>Manufacturer and Exporters</td>

                                </tr>
                                <tr>
                                        <td class="table-data">Export Percentage</td>
                                        <td>100%</td>
                                </tr>
                                <tr>
                                        <td class="table-data">Primary Competitive Advantages</td>
                                        <td> 100%
                                                Primary Competitive Advantages Impeccable quality, competitive prices
                                                and prompt
                                                delivery </td>
                                </tr>
                                <tr>
                                        <td class="table-data">No of Staff</td>
                                        <td>124</td>
                                </tr>
                                <tr>
                                        <td class="table-data">Year of Establishment </td>
                                        <td>2004</td>
                                </tr>
                                <tr>
                                        <td class="table-data">No of Production Lines</td>
                                        <td>1</td>
                                </tr>
                                <tr>
                                        <td class="table-data">Export Markets</td>
                                        <td>Worldwide</td>
                                </tr>
                                <tr>
                                        <td class="table-data">OEM Service Provided</td>
                                        <td>Yes</td>
                                </tr>

                                <tr>
                                        <td class="table-data">Production Type</td>
                                        <td>Automatic and manual</td>
                                </tr>
                                <tr>
                                        <td class="table-data">No of Designers</td>
                                        <td>2</td>
                                </tr>
                                <tr>
                                        <td class="table-data">Monthly Production Capacity</td>
                                        <td>340000 Metres Per Annum</td>
                                </tr>
                                <tr>
                                        <td class="table-data">Product Range</td>
                                        <td>Home Furnishings And Fabrics for contract
                                                Drapery panel, Pillow Covers, Bed Spreads, Bed Cover,Quilts,Upholstery
                                                Fabrics, Duvet
                                                Covers/Comforter sets made in Silk, linen, cotton, polyester and Blends.
                                        </td>
                                </tr>
                        </tbody>
                </table>
        </div>
</mat-card> -->


<!-- New about-us html -->

<!-- Our Origin Section -->
<section class="main cmargin bg-white" id="origin">
        <div class="container">
                <div class="row">
                        <div class="col-md-12 col-lg-6">
                                <div class="title text-center">
                                        <h1>Our Origin</h1>
                                </div>
                                <p class="text-p">
                                        Home Fabrics, India was founded in 2004 with primary focus on Home Furnishing
                                        Textiles. The company emphasizes creativity, ethics and hard work and is led by
                                        its President, Ramasuwamy Alakappan Singaram. With a growth rate of nearly 30%
                                        annually, it is now established as one of the leading suppliers of Home
                                        Textiles. The detail to design development, quality and general business
                                        solutions is at the heart of the growth of the company. In addition to this, the
                                        company offers a door to door solution for customers that makes it easy and
                                        effective for them to receive products on time. The company specializes in
                                        products that range from solids, embroideries, prints, and trims in fabrics like
                                        polyesters, rayon, linen, silk, bamboo and cotton. We cater and supply numerous
                                        Inherent Flame Retardant fabrics to the contract market that are tested to U.S
                                        standards and pass NFPA 701, Cal Bulletin 117 and NFPA 260.
                                </p>
                        </div>
                        <div class="col-md-12 col-lg-6">
                                <img src="assets/img/about/Office.png" alt="Office" class="img-fluid">
                        </div>
                </div>
                <div class="row mt-5">
                        <div class="col-md-12 col-lg-6 order2">
                                <a href="assets/img/about/certificate.pdf" target="_blank">
                                        <img src="assets/img/about/certificte.jpg" alt="Certificate" class="img-fluid">
                                </a>
                        </div>
                        <div class="col-md-12 col-lg-6">
                                <div class="title text-center">
                                        <h1>Credit Rating Certificate from D&B</h1>
                                </div>
                                <p class="text-p">
                                        The Dun & Bradstreet (D & B) Corporation located in New York is a company that
                                        provides commercial data, analytics, and insights for businesses. D & B has
                                        rated Home Fabrics at 3A2 which implies that the status of the entity is good.
                                        The D & B rating consists of 2 parts, the financial strength and the composite
                                        appraisal. Financial Strength is an indication of the tangible net worth and
                                        Composite Appraisal is linked to the level of risk and is an overall evaluation
                                        of creditworthiness. The financial strength is rated on a scale of 5A to 1H and
                                        the composite appraisal is rated on a scale of 1 to 5 corresponding to low risk
                                        to high risk of business depreciation. Hence, a rating of 3A2 indicates good
                                        financial strength and low risk of business.
                                </p>
                        </div>
                </div>
        </div>
</section>

<br>

<!-- Mission and Vision Section -->
<section class="main mission" id="missionandvision">
        <div class="container">
                <div class="row" style="justify-content: center;">
                        <div class="col-md-12 col-lg-8 mb-5">
                                <div class="pil">
                                        <div class="wow">
                                                <h4>Our Mission</h4>
                                                <p class="text-center">Global expansion and
                                                        furnishing our customers dreams with unique
                                                        products and designs.</p>
                                        </div>
                                </div>
                        </div>

                        <div class="col-md-12 col-lg-8">
                                <div class="pil">
                                        <div class="wow">
                                                <h4>Our Vision</h4>
                                                <p class="text-center">Achieving complete
                                                        customer satisfaction by providing guaranteed
                                                        quality and true integrity.</p>
                                        </div>
                                </div>
                        </div>
                </div>
        </div>
</section>

<br>

<!-- Administration Team Section -->
<section class="main team bg-grey" id="administration">
        <div class="container">
                <div class="title text-center">
                        <h1>Administration Team</h1>
                </div>

                <div class="row team-layout">
                        <div class="col-md-4" align="center">
                                <img src="assets/img/about/4.jpg" alt="President" class="img-fluid" width="200"
                                        height="200">
                                <h4 class="text-center">Ramasuwamy Alakappan Singaram <span
                                                style="color: black;">(President)</span></h4>
                        </div>

                        <div class="col-md-4" align="center">
                                <img src="assets/img/about/madam-3.jpg" alt="Director" class="img-fluid" width="200"
                                        height="200">
                                <h4 class="text-center">Chumathi Ramasamy <span style="color: black;">(Director)</span>
                                </h4>
                        </div>

                        <div class="col-md-4" align="center">
                                <img src="assets/img/about/3.jpg" alt="Vice President" class="img-fluid" width="200"
                                        height="200">
                                <h4 class="text-center">Ravi Kannepalli <span
                                                style="color: black;">(Vice-president)</span></h4>
                        </div>
                </div>
        </div>
</section>

<br>

<!-- Infrastructure Section -->
<section class="main bg-white" id="infrastructure">
        <div class="container">
                <div class="row">
                        <div class="col-md-6 od2">
                                <!-- Slideshow Container -->
                                <div class="slideshow-container">
                                        <div class="mySlides fade" [class.active]="currentSlide === 0"
                                                style="height:55%;">
                                                <img id="img1" src="assets/img/about/stock_racks.jpg"
                                                        (click)="openModal('assets/img/about/stock_racks.jpg')"
                                                        alt="Stock Racks" class="img-fluid">
                                        </div>

                                        <div class="mySlides fade" [class.active]="currentSlide === 1"
                                                style="height:55%;">
                                                <img id="img2" src="assets/img/about/jacquard_ machine.jpg"
                                                        (click)="openModal('assets/img/about/jacquard_ machine.jpg')"
                                                        alt="Jacquard Machine" class="img-fluid">
                                        </div>

                                        <div class="mySlides fade" [class.active]="currentSlide === 2"
                                                style="height:55%;">
                                                <img id="img3" src="assets/img/about/factory.jpg"
                                                        (click)="openModal('assets/img/about/factory.jpg')"
                                                        alt="Factory" class="img-fluid">
                                        </div>

                                        <div class="mySlides fade" [class.active]="currentSlide === 3"
                                                style="height:55%;">
                                                <img id="img4" src="assets/img/about/inspection.jpg"
                                                        (click)="openModal('assets/img/about/inspection.jpg')"
                                                        alt="Inspection" class="img-fluid">
                                        </div>

                                        <div class="mySlides fade" [class.active]="currentSlide === 4"
                                                style="height:55%;">
                                                <img id="img5" src="assets/img/about/looms.jpg"
                                                        (click)="openModal('assets/img/about/looms.jpg')" alt="Looms"
                                                        class="img-fluid">
                                        </div>

                                        <div class="mySlides fade" [class.active]="currentSlide === 5"
                                                style="height:55%;">
                                                <img id="img6" src="assets/img/about/showroom.jpg"
                                                        (click)="openModal('assets/img/about/showroom.jpg')"
                                                        alt="Showroom" class="img-fluid">
                                        </div>

                                        <div class="mySlides fade" [class.active]="currentSlide === 6"
                                                style="height:55%;">
                                                <img id="img7" src="assets/img/about/factory_racks.jpg"
                                                        (click)="openModal('assets/img/about/factory_racks.jpg')"
                                                        alt="Factory Racks" class="img-fluid">
                                        </div>

                                        <div class="mySlides fade" [class.active]="currentSlide === 7"
                                                style="height:55%;">
                                                <img id="img8" src="assets/img/about/weaving_machine.jpg"
                                                        (click)="openModal('assets/img/about/weaving_machine.jpg')"
                                                        alt="Weaving Machine" class="img-fluid">
                                        </div>

                                        <div class="mySlides fade" [class.active]="currentSlide === 8"
                                                style="height:55%;">
                                                <img id="img9" src="assets/img/about/winding_machine.jpg"
                                                        (click)="openModal('assets/img/about/winding_machine.jpg')"
                                                        alt="Winding Machine" class="img-fluid">
                                        </div>
                                </div>
                        </div>
                        <div class="col-md-6" style="padding:20px;">
                                <div class="p-details">
                                        <div class="accordion" id="accordionExample">
                                                <div class="card title">
                                                        <h1 class="text-center">Our Infrastructure</h1>
                                                        <div id="collapseThree" class="collapse show"
                                                                aria-labelledby="headingThree"
                                                                data-parent="#accordionExample">
                                                                <div class="">
                                                                        <p>Our elegant and world class infrastructure
                                                                                enables us to run our business
                                                                                effectively and efficiently. Home
                                                                                fabrics is equipped with integrated
                                                                                vertical manufacturing process including
                                                                                yarn preparation, yarn dyeing, weaving,
                                                                                finishing and stitching. It is equipped
                                                                                with technically proven high-tech modern
                                                                                technology twisting, automatic warping
                                                                                machine and advanced European dyeing and
                                                                                weaving machines. Our team of efficient
                                                                                professionals, dedicated expert workers
                                                                                and innovative designers undertake
                                                                                orders expeditiously and work to satisfy
                                                                                the requirements of the customers. All
                                                                                this is managed in about 41,400 square
                                                                                feet with the help of about 300
                                                                                employees.</p>
                                                                </div>
                                                        </div>
                                                </div>
                                        </div>
                                </div>
                        </div>
                </div>
        </div>
</section>

<!-- Image Modal -->
<div id="myModal" class="modal" tabindex="-1" [style.display]="modalDisplay" (click)="closeModal()">
        <span class="close" style="color:white;">&times;</span>
        <img class="modal-content" id="img01" [src]="modalImageSrc">
        <div id="caption"></div>
</div>

<!-- Videos Section -->
<section class="main team bg-grey">
        <div class="container">
                <div class="title text-center">
                        <h1>Videos</h1>
                </div>
                <div class="row team-layout"
                        style="justify-content: center; flex-direction: column; align-items: center;">
                        <div class="col-md-8 col-lg-6 mb-5">
                                <div class="wrapper">
                                        <button class="videoModalTriger" type="button"
                                                (click)="openVideoModal('assets/video/video1.mp4', 'videoModal1')">
                                                <img src="assets/img/about/homefabrics.jpg" alt="About Home Fabrics"
                                                        class="img-fluid video hoverable">
                                        </button>
                                </div>
                                <h4 class="text-center">About Home Fabrics</h4>
                        </div>
                        <div class="col-md-8 col-lg-6">
                                <div class="wrapper">
                                        <button class="videoModalTriger" type="button"
                                                (click)="openVideoModal('assets/video/video2.mp4', 'videoModal2')">
                                                <img src="assets/img/about/star.jpg" alt="Star Achiever Award"
                                                        class="img-fluid video hoverable">
                                        </button>
                                </div>
                                <h4 class="text-center">Star Achiever Award</h4>
                        </div>
                </div>
        </div>
</section>

<!-- Video Modal 1 -->
<div class="modal custom-modal" id="videoModal1" tabindex="-1" role="dialog" [style.display]="videoModal1Display">
        <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                        <button type="button" class="close btn-round btn-primary"
                                (click)="closeVideoModal('videoModal1')" aria-label="Close"
                                style="top: -15px; right: -15px; opacity: 1; padding: 5px 10px; z-index: 1000; position: absolute;">
                                <span aria-hidden="true">&times;</span>
                        </button>
                        <div class="video-container" style="background: #000;">
                                <iframe *ngIf="videoModal1Type === 'iframe'"
                                        [src]="videoModal1Src" allowfullscreen></iframe>
                                <video *ngIf="videoModal1Type === 'mp4'" 
                                        [src]="videoModal1Src" controls autoplay
                                        style="width: 100%; height: 100%; object-fit: contain; background: black;"></video>

                        </div>
                </div>
        </div>
</div>

<!-- Video Modal 2 -->
<div class="modal custom-modal" id="videoModal2" tabindex="-1" role="dialog" [style.display]="videoModal2Display">
        <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                        <button type="button" class="close btn-round btn-primary"
                                (click)="closeVideoModal('videoModal2')" aria-label="Close"
                                style="top: -15px; right: -15px; opacity: 1; padding: 5px 10px; z-index: 1000; position: absolute;">
                                <span aria-hidden="true">&times;</span>
                        </button>
                        <div class="embed-responsive embed-responsive-16by9" style="background: #000;">
                                <iframe *ngIf="videoModal2Type === 'iframe'" class="embed-responsive-item"
                                        [src]="videoModal2Src" allowfullscreen></iframe>
                                <video *ngIf="videoModal2Type === 'mp4'" class="embed-responsive-item"
                                        [src]="videoModal2Src" controls autoplay playsinline
                                        style="width: 100%; height: 100%; object-fit: contain; background: black;"></video>
                        </div>
                </div>
        </div>
</div>

<br>

<!-- Our Clients Section -->
<section class="main team bg-white" id="clients">
        <div class="container">
                <div class="title text-center">
                        <h1>Our Clients</h1>
                </div>
                <div class="row team-layout">
                        <div class="col-md-12">
                                <!-- <div class="client-slider">
                                        <div class="client-content hoverable"
                                                style="cursor: pointer; position: relative;">
                                                <a href="https://www.fabricut.com/" target="_blank"
                                                        style="display: block;">
                                                        <img src="assets/img/client/fabricut.png" alt="Fabricut"
                                                                class="img-fluid">
                                                </a>
                                        </div>

                                        <div class="client-content hoverable"
                                                style="cursor: pointer; position: relative;">
                                                <a href="https://www.kravet.com/" target="_blank"
                                                        style="display: block;">
                                                        <img src="assets/img/client/kravet.png" alt="Kravet"
                                                                class="img-fluid">
                                                </a>
                                        </div>

                                        <div class="client-content hoverable"
                                                style="cursor: pointer; position: relative;">
                                                <a href="https://www.maxwellfabrics.com/Homepage" target="_blank"
                                                        style="display: block;">
                                                        <img src="assets/img/client/maxwel.png" alt="Maxwell"
                                                                class="img-fluid">
                                                </a>
                                        </div>

                                        <div class="client-content hoverable"
                                                style="cursor: pointer; position: relative;">
                                                <a href="https://www.carolefabrics.com/" target="_blank"
                                                        style="display: block;">
                                                        <img src="assets/img/client/carole.png" alt="Carole"
                                                                class="img-fluid">
                                                </a>
                                        </div>

                                        <div class="client-content hoverable"
                                                style="cursor: pointer; position: relative;">
                                                <a href="https://fschumacher.com/" target="_blank"
                                                        style="display: block;">
                                                        <img src="assets/img/client/schumacher.png" alt="Schumacher"
                                                                class="img-fluid">
                                                </a>
                                        </div>

                                        <div class="client-content hoverable"
                                                style="cursor: pointer; position: relative;">
                                                <a href="https://www.estout.com/" target="_blank"
                                                        style="display: block;">
                                                        <img src="assets/img/client/staut.png" alt="Stout"
                                                                class="img-fluid">
                                                </a>
                                        </div>
                                </div> -->


                                <div class="carousel-container">
    <div class="client-slider">
        <!-- Page 1 - Clients 0-3 -->
        <div class="client-content" [style.display]="isVisible(0) ? 'block' : 'none'">
            <a href="https://www.fabricut.com/" target="_blank">
                <img src="assets/img/client/fabricut.png" alt="Fabricut" class="img-fluid">
            </a>
        </div>

        <div class="client-content" [style.display]="isVisible(1) ? 'block' : 'none'">
            <a href="https://www.kravet.com/" target="_blank">
                <img src="assets/img/client/kravet.png" alt="Kravet" class="img-fluid">
            </a>
        </div>

        <div class="client-content" [style.display]="isVisible(2) ? 'block' : 'none'">
            <a href="https://www.maxwellfabrics.com/Homepage" target="_blank">
                <img src="assets/img/client/maxwel.png" alt="Maxwell" class="img-fluid">
            </a>
        </div>

        <div class="client-content" [style.display]="isVisible(3) ? 'block' : 'none'">
            <a href="https://www.carolefabrics.com/" target="_blank">
                <img src="assets/img/client/carole.png" alt="Carole" class="img-fluid">
            </a>
        </div>

        <!-- Page 2 - Clients 4-7 -->
        <div class="client-content" [style.display]="isVisible(4) ? 'block' : 'none'">
            <a href="https://fschumacher.com/" target="_blank">
                <img src="assets/img/client/schumacher.png" alt="Schumacher" class="img-fluid">
            </a>
        </div>

        <div class="client-content" [style.display]="isVisible(5) ? 'block' : 'none'">
            <a href="https://www.estout.com/" target="_blank">
                <img src="assets/img/client/staut.png" alt="Stout" class="img-fluid">
            </a>
        </div>

        <!-- <div class="client-content" [style.display]="isVisible(6) ? 'block' : 'none'">
            <a href="#" target="_blank">
                <img src="assets/img/client/client7.png" alt="Client 7" class="img-fluid">
            </a>
        </div>

        <div class="client-content" [style.display]="isVisible(7) ? 'block' : 'none'">
            <a href="#" target="_blank">
                <img src="assets/img/client/client8.png" alt="Client 8" class="img-fluid">
            </a>
        </div> -->

        <!-- Page 3 - Clients 8-11 -->
        <!-- <div class="client-content" [style.display]="isVisible(8) ? 'block' : 'none'">
            <a href="#" target="_blank">
                <img src="assets/img/client/client9.png" alt="Client 9" class="img-fluid">
            </a>
        </div>

        <div class="client-content" [style.display]="isVisible(9) ? 'block' : 'none'">
            <a href="#" target="_blank">
                <img src="assets/img/client/client10.png" alt="Client 10" class="img-fluid">
            </a>
        </div>

        <div class="client-content" [style.display]="isVisible(10) ? 'block' : 'none'">
            <a href="#" target="_blank">
                <img src="assets/img/client/client11.png" alt="Client 11" class="img-fluid">
            </a>
        </div> -->
<!-- 
        <div class="client-content" [style.display]="isVisible(11) ? 'block' : 'none'">
            <a href="#" target="_blank">
                <img src="assets/img/client/client12.png" alt="Client 12" class="img-fluid">
            </a>
        </div> -->
    </div>

    <!-- Pagination Dots -->
    <div class="pagination-dots">
        <span *ngFor="let page of pages" class="dot" [class.active-dot]="currentPage === page" (click)="goToPage(page)">
        </span>
    </div>
</div>
                        </div>
                </div>
        </div>
</section>

<br>

<!-- Events Gallery Section -->
<!-- <section class="main bg-grey ev" id="events">
        <div class="container">
                <div class="title text-center">
                        <h1>Events</h1>
                </div>
                <div class="row team-layout">
                        Event galleries will be dynamically loaded here if you have categories data
                        <div class="col-4 col-md-3 mb15 p7" *ngFor="let category of categories">
                                <div class="title-gallery">
                                        <h1>{{ category.title }}</h1>
                                </div>
                                <a *ngFor="let gallery of category.galleries; let i = index"
                                        [class]="'elem' + (categories.indexOf(category) + 1)" [href]="gallery.images">
                                        <img *ngIf="i === 0" [src]="'category/' + category.thumb"
                                                alt="{{ category.title }}" class="img-fluid">
                                </a>
                        </div>
                </div>
        </div>
</section> -->

<section class="main bg-grey ev" id="events">
  <div class="container">
    <div class="title text-center">
      <h1>Events</h1>
    </div>
    <div class="row team-layout">
      <div class="col-4 col-md-3 mb15 p7" *ngFor="let category of categories; let count = index">
        <div class="title-gallery">
          <h1>{{ category.title }}</h1>
        </div>
        <a *ngFor="let gallery of category.galleries; let i = index"
           [class]="'elem' + (count + 1)" 
           [href]="gallery.images">
          <!-- <img *ngIf="i === 0" 
               [src]="'category/' + category.thumb"
               [alt]="category.title" 
               class="img-fluid"> -->

               <img *ngIf="i === 0" 
               [src]="'assets/banner/7f6014516e742507fa21d3c5fce7a109.jpg'"
               [alt]="category.title" 
               class="img-fluid"> 
        </a>
      </div>
    </div>
  </div>
</section>